<template>
  <form
    @submit.prevent="submit"
    class="bundle-product-family-form uk-form-stacked"
  >
    <!-- Basic Data -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend">{{$t('fieldsets.basicFields')}}</legend>

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.name"
        :label="$t('fields.name')"
        ref="nameInput"
        type="text"
        v-model="fields.values.name"
      />

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.familyNumber"
        :label="$t('fields.familyNumber')"
        type="text"
        v-model="fields.values.familyNumber"
      />

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.popularity"
        :label="$t('fields.popularity')"
        type="number"
        v-model.number="fields.values.popularity"
      />

      <radio-group-input
        :disabled="!isEditable"
        :errors="fields.errors.origin"
        :collection="availableOrigins"
        :inline="false"
        :label="$t('fields.origin')"
        v-model="fields.values.origin"
      />
    </fieldset>

    <!-- Categories -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend uk-margin">{{$t('fieldsets.categories')}}</legend>

      <product-category-assignment-manager
        :disabled="!isEditable"
        :errors="fields.errors.categories"
        :value="fields.values.categories"
        @change="fields.change.categories"
      />
    </fieldset>

    <!-- Details -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend">{{$t('fieldsets.details')}}</legend>

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.altName"
        :label="$t('fields.altName')"
        type="text"
        v-model="fields.values.altName"
      />

      <text-list-input
        :disabled="!isEditable"
        :errors="fields.errors.usps"
        :label="$t('fields.usps')"
        v-model="fields.values.usps"
      />

      <text-list-input
        :disabled="!isEditable"
        :errors="fields.errors.summaryTexts"
        :label="$t('fields.summaryTexts')"
        v-model="fields.values.summaryTexts"
      />
    </fieldset>

    <!-- SEO -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend">{{$t('fieldsets.seo')}}</legend>

      <text-input
        :disabled="!isEditable"
        :errors="fields.errors.slug"
        :label="$t('fields.slug')"
        :placeholder="slugPlaceholder"
        type="text"
        v-model="fields.values.slug"
      />

      <textarea-input
        :disabled="!isEditable"
        :errors="fields.errors.description"
        :label="$t('fields.description')"
        rows="5"
        v-model="fields.values.description"
      />
    </fieldset>

    <!-- Legal Texts -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend uk-margin">{{$t('fieldsets.legalTexts')}}</legend>

      <legal-text-manager
        :disabled="!isEditable"
        :errors="fields.errors.legalTexts"
        v-model="fields.values.legalTexts"
      />
    </fieldset>

    <!-- Documents -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend uk-margin">{{$t('fieldsets.documents')}}</legend>

      <attachment-manager
        :disabled="!isEditable"
        :errors="fields.errors.documents"
        attachment-type="DOCUMENT"
        v-model="fields.values.documents"
      />
    </fieldset>

    <div class="uk-margin-medium-top">
      <submit-button :disabled="!isSubmittable" type="primary" />
      <cancel-button />
    </div>
  </form>
</template>

<script>
import AttachmentManager from '@/components/AttachmentManager';
import CancelButton from '@/components/CancelButton';
import CommonButton from '@/components/CommonButton';
import Form from '@/mixins/Form';
import FormFieldset from '@/components/FormFieldset';
import LegalTextManager from '@/components/LegalTextManager';
import KeywordListInput from '@/components/KeywordListInput';
import ProductCategoryAssignmentManager
  from '@/components/ProductCategoryAssignmentManager';
import ProductCategoryCombobox from '@/components/ProductCategoryCombobox';
import RadioGroupInput from '@/components/RadioGroupInput';
import slugQuery from '@/api/queries/slug.graphql';
import SubmitButton from '@/components/SubmitButton';
import TextareaInput from '@/components/TextareaInput';
import TextInput from '@/components/TextInput';
import TextListInput from '@/components/TextListInput';

export default {
  name: 'bundle-product-family-form',
  mixins: [
    Form({
      altName: true,
      categories: { type: Form.Types.ReferenceList },
      documents: { type: Form.Types.ReferenceList },
      description: true,
      familyNumber: true,
      legalTexts: { type: Form.Types.ReferenceList },
      name: { required: true },
      popularity: { default: 0 },
      origin: true,
      slug: true,
      summaryTexts: { type: Form.Types.Array },
      usps: { type: Form.Types.Array },
    }),
  ],
  components: {
    AttachmentManager,
    CancelButton,
    CommonButton,
    FormFieldset,
    KeywordListInput,
    LegalTextManager,
    ProductCategoryAssignmentManager,
    ProductCategoryCombobox,
    RadioGroupInput,
    SubmitButton,
    TextareaInput,
    TextInput,
    TextListInput,
  },
  mounted() {
    this.$refs.nameInput.focus();
  },
  apollo: {
    slugPlaceholder: {
      query: slugQuery,
      variables() {
        return { value: this.fields.values.name };
      },
      fetchPolicy: 'network-only',
      debounce: { wait: 500 },
      update({ slug }) {
        return slug;
      },
      skip() {
        return !this.fields.values.name;
      },
    },
  },
  computed: {
    availableOrigins() {
      return [
        { label: 'Brodos', value: 'brodos' },
        { label: 'PXSDB', value: 'pxsdb' },
        { label: 'Manuell gepflegt', value: 'manual' },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// BundleProductFamilyForm.vue?55ce6762